// generated from 19_963 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const amplitudeCohortFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("amplitude_cohort_filter"),
  comparison_key: z.enum([
    "7", // 15_313 (76.71%)
    "8", // 4_650 (23.29%)
  ]),
  display_name: z.string(),
  // undefined: 7_978 (39.96%), defined 11_985 (60.04%)
  raw_value: z.string().optional(),
  value: z.object({
    id: z.string(),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
